// eslint-disable-next-line no-restricted-imports
import { H6 } from 'dripsy';

export default H6;
